import { groq } from "hydrogen-sanity/groq";
import { BASE_LINK, IMAGE, LINK } from "./components";

export const HEADERS = groq`
    defined(heroPrimary) => {
        heroPrimary {
            ...,
            cards[] {
                ...,
                ${LINK}
            },
            ${LINK},
            ${IMAGE}
        },
    },

     defined(heroSecondary) => {
        heroSecondary {
            ...,
            ${IMAGE},
            links[]{
                ...,
                ${BASE_LINK},
                ${IMAGE}
            }
        },
    },

    defined(heroGeneric) => {
        heroGeneric {
            ...,
            ${IMAGE}
        }
    },
`;
